// conv as returned by generateConvMatrix / generateBlurConvMatrix
// din / dout = ImageData (i.e. canvas.getContext('2d').getImageData(...))
// din and dout must have the same size !
function applyConv(conv, din, dout) {
	if (!conv.length) return;
	let width = din.width; let height = din.height; let convLen = conv.length;
	let d = din.data; let dd = dout.data;
	let i; let p; let l; let j; let x; let y; let dx; let dy; let pos; let tr; let tg; let tb; let appliedWeight;
	for (i = 0, l = d.length; i < l; i += 4) {
		p = i >> 2; y = ~~(p / width); x = p - width * y;
		tr = tg = tb = 0;
		for (j = 0; j < convLen; j += 3) {
			dx = x + conv[j];
			dy = y + conv[j + 1];
			// Strategy: edge pixel duplication
			// (for outside pixels, consider the color to be the same as the closest pixel inside the image)
			if (dx < 0) dx = 0;
			if (dx >= width) dx = width - 1;
			if (dy < 0) dy = 0;
			if (dy >= height) dy = height - 1;
			pos = ((dx + dy * width) << 2);
			appliedWeight = conv[j + 2];
			tr += appliedWeight * d[pos];
			tg += appliedWeight * d[pos + 1];
			tb += appliedWeight * d[pos + 2];
		}
		dd[i] = tr;
		dd[i + 1] = tg;
		dd[i + 2] = tb;
		dd[i + 3] = d[i + 3]; // Duplicate alpha channel
	}
}

// e.g. 'sharper' effect :
// generateConvMatrix([
// 	[ 0, -1,  0],
// 	[-1,  5, -1],
// 	[ 0, -1,  0]]);
// If normalize is true, the values will be normalized (divided by the sum)
function generateConvMatrix(arr, normalize) {
	let center = [(arr[0].length - 1) >> 1, (arr.length - 1) >> 1];
	let linearConv = [];
	let totalWeight = 0;

	arr.forEach((line, i) => {
		line.forEach((elem, j) => {
			if (!elem) return; // We can safely remove zeroes in this representation
			totalWeight += elem;
			linearConv.push(j - center[0], i - center[1], elem);
		});
	});

	if (normalize && totalWeight) {
		for (let i = 0, l = linearConv.length; i < l; i += 3) {
			linearConv[i + 2] /= totalWeight;
		}
	}

	return linearConv;
}

// Bigger radius = longer processing
function generateBlurConvMatrix(rad) {
	let totalWeight = 0;
	let hSize = (rad >> 1);
	let linearConv = [];

	for (let i = 0; i < rad; i++) {
		let y = i - hSize;
		for (let j = 0; j < rad; j++) {
			let x = j - hSize;
			// var weight = 1; // square uniform blur
			let weight = 1 / (x * x + y * y + 1); // ~ gaussian blur (I think)
			totalWeight += weight;
			linearConv.push(x, y, weight);
		}
	}

	// Normalize
	if (totalWeight) {
		for (let i = 0, l = linearConv.length; i < l; i += 3) {
			linearConv[i + 2] /= totalWeight;
		}
	}
	return linearConv;
}

export {
	applyConv,
	generateConvMatrix,
	generateBlurConvMatrix
};
